import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import Marquee from "@/components/Marquee";
import ServicesGrid from "@/components/ServicesGrid";
import MethodSection from "@/components/MethodSection";
import AboutSection from "@/components/AboutSection";
import TestimonialsFaq from "@/components/TestimonialsFaq";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  const [selectedService, setSelectedService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB] font-sans text-slate-800 antialiased">
      <Navbar />
      <main>
        <HeroSection />
        <Marquee />
        <ServicesGrid onSelectService={setSelectedService} />
        <MethodSection />
        <AboutSection />
        <TestimonialsFaq />
        <ContactSection selectedService={selectedService} onSelectService={setSelectedService} />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
